import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth35: ToothDataEntry = {
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M119.7,395.1l.9,3.3,1.1,5.8,1.6,6.7s.9,5.8,1,6.3,1.5,6.6,1.5,6.6v19.3c0,0-.7,6.1-.7,6.1l-.9,4.4-1.8,5.3-4.4,7.2-2.6,1.8-9.3,3.2-3.8.5-17.4,2-19.9,2.8-21.6.4-12-3-10.2-3.5-6.7-4-3.7-4-1.3-5.1-.8-16.1,4-21.1,6.9-22.9s33.2-18.6,100.1-2Z',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M119.7,395.1l.9,3.3,1.1,5.8,1.6,6.7s.9,5.8,1,6.3,1.5,6.6,1.5,6.6v19.3c0,0-.7,6.1-.7,6.1l-.9,4.4-1.8,5.3-4.4,7.2-2.6,1.8-9.3,3.2-3.8.5-17.4,2-19.9,2.8-21.6.4-12-3-10.2-3.5-6.7-4-3.7-4-1.3-5.1-.8-16.1,4-21.1,6.9-22.9s33.2-18.6,100.1-2Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M19.6,397.1s32.9-18.6,100.1-2l-1.7-6.2s-56.6-17.6-97.1,1.7l-1.3,6.6Z',
			},
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M19.6,397.1s33.5-19.2,100.1-2l2.5,12.7h-25.1s-9.6-.3-9.6,7.8.1,24.6.1,24.6h-37.2v-24.4s-.9-8-9.3-8-24,0-24,0l2.5-10.7Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M17.1,407.8h24c8.3,0,9.3,8.1,9.3,8.1v61.7l-16.3-1.7-14.2-4.6-6.1-4.4-3.7-5.3-1.8-5v-14.2l3.2-18.5,5.6-16.1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M122.2,407.9h-25.1s-9.6-.4-9.6,7.8v24.6c.1,0,.1,33.6.1,33.6l17.6-2.2,8.8-2.6,4.8-3.5,4.6-8.2,2.5-9.5,1-6.4-1.2-18.9-3.4-14.7Z',
			},
			[ToothSurface.LingualCusp]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '50.4 440.3 87.6 440.3 126.1 440.3 125.7 447.5 124.4 454 123.3 458.5 118 466.4 116.6 467.8 104.1 472.3 84.9 474.5 71.6 477 40.8 477 26.4 473.8 16.8 469.8 11.7 464.1 8.2 456.5 8.2 440.3 50.4 440.3',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'10.1 443 24.6 427 28 453.1 39.4 422 47.9 453.1 58.6 420.4 68.3 451.3 78.7 420.4 88.1 451.6 98.3 420.4 106.1 450.8 112 425.8 123.6 443.8',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'126.6 69.3 115.6 79.8 122.6 91.3 108.1 93.3 117.1 107.9 101.1 111.9 111.1 125.4 94.6 127.9 104.1 143.4 86.1 154.9 96.1 167 78 173 91.6 186.5 74.3 196.2 87.8 205.2 70.8 214 85.6 223.7 70.5 231.4 85.5 241.2 71 248.8 86.2 258.8 71.1 266.5 84.1 275 71.6 281.5 84.9 290.3 71.6 297 84.9 305.8 70.7 313 83.3 321.3 70.3 327.9 82.9 336.1 66.7 344.4 79.5 352.9 65.4 360.1 78.6 368.9 62.9 377 76.8 386.2 59.8 394.9 73.6 404',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'42.7 262.6 50.4 252.6 57.8 262.9 66.5 251.5 75.6 262.9 83 251 91.1 261 98 252.6 103.7 261.7 109.3 251.5 113.9 261.3',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '16.9 72.5 29.9 53.3 44.7 39.1 63.2 29.7 78.6 27.1 98.4 29.5 116.5 39.3 127 51.2 139.8 80.9 142.3 99.8 142.7 118.8 140 135.7 134.2 151.2 120.1 167 103.9 174.7 84.7 178.7 60 178.7 40 171.1 23.8 155.7 13.1 135.7 11.8 112 12.7 92.6 16.9 72.5',
			},
			[ToothSurface.LingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M21.5,66.4l5.9-10.4,14.7-15.1,19.4-10.8,18.8-3.5,20,3.1,16.6,9.2,11.6,13.5,6.9,14.7s-4.8,3.9-10.6,7.7-11.7,7.2-15.4,7.2c-11.9,0-20.2-8-32.3-8s-18.4,9.4-30.9,9.4-9.7-4.2-15.1-8.5-9.9-8.5-9.9-8.5h.3Z',
			},
			[ToothSurface.BuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M14.8,139l8,15.7,17,16.3,21.5,8.4,23.7.4,19-4.9,16.8-8,13.7-14.5,4.1-11.2s-4.8-5.1-11.3-9.8c-5.6-4-12.5-7.8-18.7-7.8-13.5,0-19.6,9.6-31.9,9.6s-23.1-11.4-36.2-11.4-12.2,3.8-16.9,7.9c-5.2,4.5-8.7,9.3-8.7,9.3h-.1Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M21.5,66.4l9.9,8.5s26.5,27.5-7.9,54.7l-8.7,9.3s-10-43.3,6.7-72.5Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M135.5,67l-10.6,7.7s-33.4,28.4,2.1,56.6l11.3,9.8s13.3-30-2.9-74.2h0Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M31.4,74.9s9.9,8.5,15.1,8.5c13,0,18.1-9.4,30.9-9.4s20.5,8,32.3,8,15.4-7.2,15.4-7.2c0,0-33.1,27.4,2.1,56.6,35.2,29.2-3.8-7.8-18.7-7.8s-18.6,9.6-31.9,9.6-22.8-11.4-36.2-11.4-16.9,7.9-16.9,7.9c0,0,33.6-23.8,7.9-54.7h0Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '133.9 149.7 21.4 149.7 23 155.6 40.3 171.3 60.8 179.2 86.1 179.5 103.9 174.3 121.3 165.9 132.5 153.8 133.9 149.7',
			},
			[ToothSurface.LingualSurface]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '128.3 54.1 29.5 54.1 40.8 41.5 50.2 36.3 64.9 28.2 83.6 26.8 101 29.3 115.9 38.3 124.9 48 128.3 54.1',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'13.3 101.1 29.7 117.1 33.6 90.9 46.3 122.1 56.1 90.9 67.9 123.7 78.9 92.8 90.7 123.7 101.4 92.5 112.8 123.7 121.6 93.3 128.2 118.2 141.4 100.3',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M19.5,143.3l-5.9-38.1-5.3-26.6-2.6-15.5,1.2-11.7,2.6-5.7,9.3-7.2,12.7-2.4h29.6l53.6,8.4,18.1,6.4,6.7,6.2,2.4,9.6.5,15.5-1.7,8.6-15.5,44.2-2.7,11.2c-44.7,32.5-103.1-2.9-103.1-2.9Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M19.5,143.3s58.3,35.4,103.1,2.9l-2.8,14.3s-36.4,23-100.4-4.7v-12.5Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M19.5,143.3s58.2,35.7,103.1,2.9l4.6-15.7-17.6-.3s-12.3.3-12.3-10.6v-39.6l-47.9-.6.4,38.4s1,12.4-10.9,12.4h-21.3l1.9,13Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M49.8,117.9l-.4-38.4v-43.8h-15.3l-15.7,2.8-6.2,3.6-5.8,10.2v16.9l11.2,61.2h21.3s10.9,1.2,10.9-12.4Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M97.3,119.7V42l18.1,2.8,21,8.1,5.5,8.8.7,5.3v15.5l-1.7,8.8-13.7,39.3-17.6-.3s-12.3.2-12.3-10.6Z',
			},
			[ToothSurface.BuccalCusp]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '97.3 80.1 49.4 79.5 8.1 79.5 6 63.6 6.4 52.8 10.1 43.8 18.7 37.8 31.2 35.4 65 36.2 116 44.4 136.5 52.8 141.2 58.7 142.4 65.3 142.4 80.6 97.3 80.1',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M19.5,143.3l-5.9-38.1-5.3-26.6-2.6-15.5,1.2-11.7,2.6-5.7,9.3-7.2,12.7-2.4h29.6l53.6,8.4,18.1,6.4,6.7,6.2,2.4,9.6.5,15.5-1.7,8.6-15.5,44.2-2.7,11.2c-44.7,32.5-103.1-2.9-103.1-2.9Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'10.7 87.1 26.9 105 30.8 75.6 43.6 110.7 53.2 75.6 65.1 112.5 76 77.8 87.9 112.5 98.5 77.4 109.9 112.5 118.6 78.3 125.2 106.4 138.5 86.3',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'92.5 440.8 73.2 427 85.4 417.3 70.7 411.1 85 403.5 67.4 394.3 81.2 386.8 65.3 380.9 78.3 370.5 63.2 365 75.7 354.5 61.1 347 74.9 338.2 60.3 329.8 73.2 321.5 58.2 315.2 72.4 305.6 56.5 299.7 69.5 289.7 55.7 283.4 67 276.3 55.2 267.5 70.6 258.7 57 252.6 68.6 245 55.2 238.9 67.4 230.9 54.7 225.1 65.9 217.8 53.2 212 67.4 202.9 54.2 197 66.4 189 53.1 182.9 67.4 177.5 52.5 167.5 71.1 162.4 59.8 152.3',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'26.7 265.1 34.7 278.7 42.4 264.8 51.6 280 61 264.8 68.8 280.6 77.4 267.4 84.6 278.7 90.6 266.4 96.3 280 101.3 267.1',
			],
		},
	},
};
